//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTrueFalse } from '../../../../../components/helpers.js'
import { axiosPost } from '../../../../../axios/axios.js'

export default {
  props: {
    brigade: {
      type: Object,
      default () {
        return {}
      }
    },
    requests: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      loading: false,
      requestsLocal: JSON.parse(JSON.stringify(this.requests)),
      columns: [
        {
          name: 'key',
          label: 'Номер заявки',
          field: 'key',
          align: 'left',
          sortable: true
        },
        {
          name: 'state',
          label: 'Статус',
          field: 'stateName',
          align: 'left',
          sortable: true
        },
        {
          name: 'objectAlias',
          label: 'Объект',
          field: 'objectAlias',
          align: 'left',
          sortable: true
        },
        {
          name: 'autoAssigned',
          label: 'Назначена автоматически',
          field: 'autoAssigned',
          format: formatTrueFalse,
          align: 'left',
          sortable: true
        }
      ]
    }
  },
  watch: {
    requests: function (newVal) {
      this.requestsLocal = JSON.parse(JSON.stringify(newVal))
    }
  },
  methods: {
    onCancelExecutorAssignment: function (request) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            this.cancelExecutorAssignment(request)
          }
        },
        header: 'Подтвердите отмену назначения исполнителя',
        warning: [`Бригаде ${this.brigade.name} будет отменено назначение на заявку ${request.key}`],
        buttons: {
          yes: 'Продолжить',
          no: 'Отмена'
        }
      })
    },
    cancelExecutorAssignment: function (request) {
      const bodyFormData = new FormData()
      bodyFormData.set('requestId', request.id)

      bodyFormData.append('cancelAppointmentAction', 'none')

      this.loading = true

      return axiosPost({
        url: '/service/delta/request/cancelAssignment',
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Назначение отменено',
            progress: true,
            timeout: 3000
          })
          this.requestsLocal = this.requestsLocal.filter(r => r.id !== request.id)
        },
        onFailure: (response) => {
          const errMsg = response.message || 'Ошибка отмены назначения'
          this.$q.notify({
            type: 'negative',
            message: errMsg,
            progress: true,
            timeout: 8000
          })
          return Promise.reject(new Error(errMsg))
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

